import React, { memo, ReactNodeArray, useCallback, useMemo, useContext, useState } from 'react'
import { ScreenContext, Carousel } from 'react-components'

import { BenefitsSectionTransport } from '@common/transports/deprecated-home-page-transport'
import { Container, Dot, SliderContainer, Title, NonCarouselContainer } from './benefits-section-styles'
import BenefitsCardBasic from './benefits-card-basic'
import BenefitsCardIndex from './benefits-card-index'

type Props = {
    benefitsSectionData: BenefitsSectionTransport
}

const getCardContent = (benefitsSectionData: BenefitsSectionTransport, shadowed: boolean) => {
    const cardContent =
        benefitsSectionData &&
        benefitsSectionData.benefits.map(benefit => (
            <BenefitsCardBasic key={benefit.title} benefit={benefit} shadowed={shadowed} />
        ))

    cardContent.unshift(<BenefitsCardIndex key={benefitsSectionData.id} benefits={benefitsSectionData.benefits} />)
    return cardContent
}

const _appendDots = (dots: ReactNodeArray) => <SliderContainer>{dots}</SliderContainer>

const BenefitsSection: React.FC<Props> = ({ benefitsSectionData }) => {
    const [currentSelection, updateCurrentSelection] = useState<number>(0)
    const carouselCardContent = useMemo(() => getCardContent(benefitsSectionData, true), [benefitsSectionData])
    const { isMobile } = useContext(ScreenContext)
    const nonCarouselCardContent = useMemo(
        () => getCardContent(benefitsSectionData, false).slice(1),
        [benefitsSectionData],
    )

    const _beforeChange = useCallback(
        (_lastIndex, nextIndex) => {
            updateCurrentSelection(nextIndex)
        },
        [updateCurrentSelection],
    )

    const _customPaging = useCallback(index => <Dot selected={index === currentSelection} />, [currentSelection])

    return (
        <Container id={benefitsSectionData.id}>
            <Title>{benefitsSectionData.title}</Title>
            {isMobile && (
                <Carousel
                    arrows={false}
                    infinite={false}
                    centerMode
                    centerPadding={'16px'}
                    customPaging={_customPaging}
                    appendDots={_appendDots}
                    beforeChange={_beforeChange}
                    dots
                >
                    {carouselCardContent}
                </Carousel>
            )}
            {!isMobile && <NonCarouselContainer>{nonCarouselCardContent}</NonCarouselContainer>}
        </Container>
    )
}

export default memo(BenefitsSection)
